import React from "react";

const InputScreenSize = (props) => {
    const {store} = props;

    console.log("rendering InputScreenSize", store.getState().screenSize)

    return (
        <>
            <input type="number"
                   className="form-control"
                   id="screen_size_input"
                   name="screen_size_input"
                   value={store.getState().screenSize}
                   onInput={e => store.dispatch({type: 'CHANGE_SCREEN_SIZE', data: e.target.value})}
            />
        </>
    )
}

export default InputScreenSize
